
export const GET_SYSTEM_SETTINGS = "GET_SYSTEM_SETTINGS"
export const GET_SYSTEM_SETTINGS_SUCCESS = "GET_SYSTEM_SETTINGS_SUCCESS"
export const GET_SYSTEM_SETTINGS_FAIL = "GET_SYSTEM_SETTINGS_FAIL"

export const UPDATE_SYSTEM_SETTINGS = "UPDATE_SYSTEM_SETTINGS"
export const UPDATE_SYSTEM_SETTINGS_SUCCESS = "UPDATE_SYSTEM_SETTINGS_SUCCESS"
export const UPDATE_SYSTEM_SETTINGS_FAIL = "UPDATE_SYSTEM_SETTINGS_FAIL"
